import React from "react"
import PropTypes from "prop-types"
import SanityImage from "gatsby-plugin-sanity-image"
import TextBlock from "components/TextBlock"
import theme from "styles/theme"

/**
 * Visually distinct "card" for embedding into ArticleBlock content.
 */
const ArticleStoryCard = ({ title, copy, image, alt, className }) => (
  <div
    css={{
      background: theme.midBlue,
      color: theme.white,
      margin: "72px 0",
      [theme.tabletSmall]: {
        margin: "60px 0",
      },
      [theme.mobilePortrait]: {
        // Note: There's stacked padding on the parent section, and while
        // I don't think it's important to keep, changing the system or
        // fixing the fragmentation will need to wait for another day
        marginLeft: "calc(-1 * var(--inlinePadding) - 10px)",
        marginRight: "calc(-1 * var(--inlinePadding) - 10px)",
      },
    }}
    className={className}
  >
    {image && (
      <SanityImage
        {...image}
        width={649}
        alt={alt}
        css={{ display: "block", width: "100%" }}
      />
    )}

    <div
      css={{
        padding: 32,
        [theme.tabletSmall]: {
          padding: "16px 24px",
        },
        [theme.mobile]: {
          padding: "24px calc(var(--inlinePadding) + 10px)",
        },
      }}
    >
      <h3 css={theme.t4}>{title}</h3>
      <TextBlock css={{ color: theme.white }}>{copy}</TextBlock>
    </div>
  </div>
)

export default ArticleStoryCard

ArticleStoryCard.propTypes = {
  title: PropTypes.string.isRequired,
  copy: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  image: PropTypes.shape({
    asset: PropTypes.shape({
      _ref: PropTypes.string.isRequired,
    }).isRequired,
  }),
  alt: PropTypes.string,
  className: PropTypes.string,
}
